import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import axios from "axios";
import "./ShareCardModal.css"; // קובץ סגנון נפרד אם תרצי

export default function ShareCardModal({
  isOpen,
  onClose,
  onShareStatusChange,
}) {
  const [share, setShare] = useState(false);
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [freeText, setFreeText] = useState("");
  const [cellFriend, setCellFriend] = useState("");
  const [keyImage1, setKeyImage1] = useState("");
  const [shareStatus, setShareStatus] = useState(0);
  const [shareRequestDate, setShareRequestDate] = useState(null);
  const [sharePersonNote, setSharePersonNote] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const FREE_TEXT_PREVIEW_LENGTH = 20;

  const freeTextPreview =
    freeText.length > FREE_TEXT_PREVIEW_LENGTH
      ? freeText.slice(0, FREE_TEXT_PREVIEW_LENGTH).trim() + "..."
      : freeText;
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const formatShareDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("he-IL");
  };

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/PshareCardData",
          config,
        );
        const userData = response.data;
        if (userData[0].length > 0) {
          setFreeText(userData[0][0].freeText);
          setCellFriend(userData[0][0].cellFriend);
          setKeyImage1(userData[0][0].keyImage1);
          setShareStatus(userData[0][0].shareStatus || 0);
          setShareRequestDate(userData[0][0].shareRequestDate || null);
          setSharePersonNote(userData[0][0].sharePersonNote || "");

          setIsDataLoaded(true);
        } else {
          // in case there is no data
        }
      } catch (error) {
        // probebly user is not authenticated or server is down
      }
    };
    loadData();
  }, []);

  const handleSubmit = async () => {
    setIsErrorMessageDisplayed(false);

    if (!share) {
      alertUser("כדי לשלוח בקשת שיתוף יש לסמן קודם את אישור הפרסום.");
      return;
    }

    if (
      cellFriend === "0" ||
      freeText === "0" ||
      keyImage1 === "0" ||
      cellFriend.trim() === "" ||
      freeText.trim() === "" ||
      keyImage1.trim() === ""
    ) {
      alertUser(
        "כדי לשתף את הכרטיס שלך בסטטוס של דאבל, יש לוודא שיש בו טלפון של חבר ליצירת קשר, טקסט חופשי ותמונה ראשית. נא לעדכן את הפרטים החסרים ולנסות שוב.",
      );
      return;
    }
    setIsLoading(true);
    if (
      cellFriend === "0" ||
      freeText === "0" ||
      keyImage1 === "0" ||
      cellFriend.trim() == "" ||
      freeText.trim() == "" ||
      keyImage1.trim() == ""
    ) {
      alertUser(
        "כדי לשתף את הכרטיס שלך בסטטוס של דאבל, יש לוודא שיש בו טלפון של חבר ליצירת קשר, טקסט חופשי ותמונה ראשית. נא לעדכן את הפרטים החסרים ולנסות שוב.",
      );
    } else {
      try {
        const response = await axios.post(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/PShareCard",
          {
            note: note,
          },
          config,
        );

        if (response.status === 200) {
          const now = new Date();

          setShareStatus(1);
          setShareRequestDate(now);
          setSharePersonNote(note);
          onShareStatusChange?.(1, now);

          alertUser("תודה! בקשת הפירסום נשמרה בהצלחה.");
        } else {
          alertUser("שגיאה בשמירה, נסה שוב מאוחר יותר.");
        }
      } catch (err) {
        console.error(err);
        alert("שגיאה בחיבור לשרת.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCancelShare = async () => {
    setIsLoading(true);
    setIsErrorMessageDisplayed(false);

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PCancelShareCard",
        {},
        config,
      );

      if (response.status === 200) {
        setShareStatus(2);
        onShareStatusChange?.(2, null);
        alertUser("בקשת השיתוף בוטלה בהצלחה.");
      } else {
        alertUser("לא ניתן היה לבטל את הבקשה.נא לנסות שוב מאוחר יותר.");
      }
    } catch (err) {
      console.error(err);
      alertUser("שגיאה בחיבור לשרת.");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  const areShareDetailsComplete =
    cellFriend !== "0" &&
    freeText !== "0" &&
    keyImage1 !== "0" &&
    cellFriend.trim() !== "" &&
    freeText.trim() !== "" &&
    keyImage1.trim() !== "";

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 style={{ marginTop: "0" }}>
          {" "}
          שיתוף הכרטיס שלי בערוצי המדיה של דאבל
        </h3>

        {shareStatus === 1 && (
          <div
            style={{
              marginBottom: "10px",
              textAlign: "center",
            }}
          >
            <b>
              ✅ קיימת בקשת שיתוף פעילה מתאריך{" "}
              {formatShareDate(shareRequestDate)}
            </b>
          </div>
        )}

        <p>לפני השיתוף, צריך לראות שיש פרטים בסיסיים:</p>
        <div>
          <b>טלפון של חבר/ה ליצירת קשר:</b>
          {cellFriend > "0" && cellFriend.trim() != ""
            ? "✅ הטלפון שמופיע הוא " + cellFriend
            : "❌ לא מופיע, נא לעדכן"}
          <br />
          <b>טקסט חופשי:</b>
          {freeText !== "0" && freeText.trim() !== "" ? (
            <>✅ קיים: {freeTextPreview}</>
          ) : (
            "❌ אין טקסט חופשי, נא לעדכן"
          )}

          <b>תמונה ראשית:</b>
          {keyImage1 && keyImage1 !== "0" && keyImage1.trim() != ""
            ? "✅ יש תמונה ראשית. "
            : "❌ אין תמונה ראשית, נא לעדכן"}
        </div>
        {!areShareDetailsComplete && <Link to="/pics">השלמת הפרטים</Link>}
        <div
          className="mainButton"
          style={{
            textDecoration: "none",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          <a href="/myProfile" target="_blank" rel="noopener noreferrer">
            איך הפרופיל שלי נראה?{" "}
          </a>
        </div>

        <p>
          {shareStatus === 1
            ? "רוצה לחדש את בקשת השיתוף?"
            : 'בסימון "כן" אני מבקש/ת מדאבל לשתף את הכרטיס שלי בערוצי המדיה של דאבל, לרבות סטטוס WhatsApp ו־Instagram.'}
        </p>
        <div className="checkbox-row">
          <input
            type="checkbox"
            checked={share}
            onChange={(e) => setShare(e.target.checked)}
          />
          <label>
            אני מאשר/ת לדאבל לפרסם את הכרטיס שלי בערוצי המדיה של דאבל
          </label>
        </div>

        <div
          style={{
            fontSize: "13px",
            textAlign: "center",
            marginBottom: "8px",
          }}
        >
          הפרסום עשוי להתבצע במועד מאוחר יותר.
        </div>
        <div className="note-container">
          <textarea
            className="freetext"
            style={{ height: "50px" }}
            placeholder={`רוצה להוסיף הערה? (עד ${60} תווים)`}
            value={note}
            maxLength={60}
            onChange={(e) => setNote(e.target.value)}
          />

          <div className="note-counter">
            {note.length}/{60}
          </div>
        </div>

        {shareStatus === 1 && (
          <div style={{ textAlign: "center", marginTop: "8px" }}>
            <button
              type="button"
              onClick={handleCancelShare}
              disabled={isLoading}
              style={{
                border: "none",
                background: "none",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              ביטול בקשת השיתוף הפעילה
            </button>
          </div>
        )}

        <div className="buttons">
          <button onClick={onClose}>סגירה</button>
          <button
            style={{
              background:
                isLoading || !share ? "#ccc" : "var(--btn-home-color)",
            }}
            onClick={handleSubmit}
            disabled={isLoading || !share}
          >
            {isLoading ? "שומר..." : "שמירה"}
          </button>
        </div>

        <div
          style={{
            textAlign: "center",
            fontSize: "13px",
            marginTop: "10px",
          }}
        >
          רואים אותנו גם ב־
          <a
            href="https://instagram.com/double2love.ai?igshid=MzNlNGNkZWQ4Mg=="
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          {" | "}
          <a
            href="https://chat.whatsapp.com/D20V9ddb0nPJT4qVhtF3mP"
            target="_blank"
            rel="noopener noreferrer"
          >
            קבוצת WhatsApp
          </a>
        </div>
        {isErrorMessageDisplayed && (
          <div className="error-message">
            <h5>{errorMessage} </h5>
          </div>
        )}
      </div>
    </div>
  );
}
